<template>
	<div
		class="steam-videos insicht insicht--fade-in"
		:class="[
			moduleSpacing,
		]"
		v-if="videos.length"
	>
		<div
			class="steam-videos__tabs"
			:class="[
				bgColor
			]"
		>
			<button
				v-for="(video, index) in videos"
				:key="`steam-video-tab-${index}`"
				class="steam-videos__tab"
				:class="{
					'steam-videos__tab--active': activeTab == index
				}"
				@click="onTabClick(index)"
			>
				<component
					:is="iconComponent(video.icon)"
					class="steam-videos__tab-icon"
				/>
				<span
					class="steam-videos__tab-title"
					v-html="video.title"
				/>
			</button>
		</div>
		<h3
			class="steam-videos__title"
			v-html="activeTitle"
		/>
		<div class="steam-videos__video">
			<div class="media-container media-container--landscape">
				<figure
					v-if="showPoster"
					class="steam-videos__video-poster"
					@click="onPosterClick()"
				>
					<img
						class="steam-videos__video-poster-element"
						:srcset="activeVideo.poster.srcset"
						:src="activeVideo.poster.src"
						:alt="activeVideo.title"
						data-object-fit
						loading="lazy"
					>
					<button type="button" class="steam-videos__video-poster-button">
						<SVGPlay class="steam-videos__video-poster-icon"/>
					</button>
				</figure>
				<iframe
					v-else
					class="steam-videos__video-iframe"
					:src="videoUrl"
					frameborder="0"
					allow="accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				/>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			bgColor: this.$root.options.bgColor,
			moduleSpacing: this.$root.options.moduleSpacing,
			videos: this.$root.options.videos,
			activeTab: 0,
			showPoster: true,
		}
	},
	computed: {
		activeVideo() {
			return this.videos[this.activeTab];
		},
		activeTitle() {
			return this.activeVideo.title;
		},
		videoUrl() {
			if (this.activeVideo.videoPlatform == 'vimeo') {
				return `https://player.vimeo.com/video/${this.activeVideo.videoId}?autoplay=1&title=0&byline=0&portrait=0`;
			}
			else if (this.activeVideo.videoPlatform == 'youtube') {
				return `https://www.youtube.com/embed/${this.activeVideo.videoId}?autoplay=1`;
			}

			return '';
		}
	},
	methods: {
		onTabClick(index) {
			this.activeTab = index;
			this.showPoster = true;
		},
		onPosterClick() {
			this.showPoster = false;
		}
	}
}
</script>

<style>

</style>
